export default __webpack_public_path__ + "static/media/cliente_activo.2e78fe9e.svg";